import { Navigate } from "react-router-dom";
import { isAdminUser } from "../../utils/authRoleHelpers";

const AdminOnlyRoute = ({ children }) => {
  if (!isAdminUser()) {
    return (
      <Navigate
        to="/403"
        replace
        state={{ message: "دسترسی به این بخش فقط برای مدیر سیستم مجاز است." }}
      />
    );
  }
  return children;
};

export default AdminOnlyRoute;
